export const RECEIVED_FRIENDS_OPINIONS = "RECEIVED_FRIENDS_OPINIONS";
